// Auto-generated by scripts/fetch-nova-scotia-facilities.js
// Source: Overpass API (OpenStreetMap) — Nova Scotia healthcare facilities
// Generated: 2026-04-22T18:48:16.755Z
// ERs: 24 (non-CDN only — CDN ERs loaded live from NS Health API)
// Walk-ins: 28
// Pharmacies: 138

export const NS_FACILITIES = [
  {
    id: "er-001",
    name: "Musquodoboit Valley Memorial Hospital",
    city: "Middle Musquodoboit",
    address: "492 Archibald Brook Road",
    phone: "(902) 384-2220",
    lat: 45.0403498,
    lng: -63.1403411,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-002",
    name: "Roseway Hospital",
    city: "Shelburne",
    address: "1606 Lake Road",
    phone: "(902) 875-3011",
    lat: 43.7492064,
    lng: -65.3097898,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-003",
    name: "Bayview Memorial Health Care Centre",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.3461894,
    lng: -64.7947624,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-004",
    name: "Rawdon Hills Health Centre",
    city: "Upper Rawdon",
    address: "3889 Highway 14",
    phone: "Not listed",
    lat: 45.0671247,
    lng: -63.713291,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-005",
    name: "Eastern Shore Memorial Hospital",
    city: "Sheet Harbour",
    address: "22637 Highway 7",
    phone: "(902) 885-2554",
    lat: 44.9207756,
    lng: -62.5327695,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-006",
    name: "Twin Oaks Memorial Hospital",
    city: "",
    address: "7704 Highway 7",
    phone: "(902) 889-2200",
    lat: 44.7829962,
    lng: -63.1582526,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-007",
    name: "Strait Richmond Hospital",
    city: "Evanston",
    address: "138 Hospital Road",
    phone: "(902) 625-3100",
    lat: 45.6172067,
    lng: -61.22293,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-008",
    name: "IWK Health Centre",
    city: "Halifax",
    address: "5850/5980 University Avenue",
    phone: "Not listed",
    lat: 44.6377282,
    lng: -63.5836986,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-009",
    name: "Guysborough Memorial Hospital",
    city: "Guysborough",
    address: "10560 Highway 16",
    phone: "(902) 533-3702",
    lat: 45.4023533,
    lng: -61.5071217,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-010",
    name: "New Waterford Consolidated Hospital",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.2399417,
    lng: -60.085764,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-011",
    name: "Glace Bay Health Care Facility",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.1832091,
    lng: -59.939009,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-012",
    name: "Eastern Kings Memorial Community Health Centre",
    city: "Wolfville",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.0876487,
    lng: -64.3708119,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-013",
    name: "Digby General Hospital",
    city: "Digby",
    address: "75 Warwick Street",
    phone: "(902) 245-2501",
    lat: 44.6165044,
    lng: -65.7616986,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-014",
    name: "Eastern Memorial Hospital",
    city: "Canso",
    address: "1746 Union Street",
    phone: "(902) 366-2794",
    lat: 45.3327264,
    lng: -60.9841336,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-015",
    name: "Harbour View Hospital",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.2346476,
    lng: -60.2225282,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-016",
    name: "Northside General Hospital",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.2182004,
    lng: -60.2359824,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-017",
    name: "Victoria County Memorial Hospital",
    city: "Baddeck",
    address: "30 Old Margaree Road",
    phone: "(902) 295-2112",
    lat: 46.1003359,
    lng: -60.7559763,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-018",
    name: "Sacred Heart Community Health Centre",
    city: "Cheticamp",
    address: "15102 Cabot Trail",
    phone: "(902) 224-4000",
    lat: 46.6235036,
    lng: -61.0156075,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-019",
    name: "North Cumberland Memorial Hospital",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.8561273,
    lng: -63.6589097,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-020",
    name: "Soldiers' Memorial Hospital",
    city: "Middleton",
    address: "462 Main Street",
    phone: "(902) 825-3411",
    lat: 44.9468009,
    lng: -65.059352,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-021",
    name: "Sutherland Harris Memorial Hospital",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.6765927,
    lng: -62.7270305,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-022",
    name: "Pictou Landing Health Centre",
    city: "Fisher's Grant 24",
    address: "19 Maple Street",
    phone: "Not listed",
    lat: 45.6747349,
    lng: -62.652764,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-023",
    name: "Fisherman's Memorial Hospital",
    city: "Lunenburg",
    address: "14 High Street",
    phone: "(902) 634-8801",
    lat: 44.3824265,
    lng: -64.3272313,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "er-024",
    name: "Dr. Kingston Memorial Community Health Centre",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.611234,
    lng: -60.7737013,
    type: 'er' as const,
    waitMinutes: 90,
    volume: 'moderate' as const,
    hasLiveData: false as const,
  },
  {
    id: "wk-001",
    name: "Westville Medical Clinic",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.5592001,
    lng: -62.7135884,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-002",
    name: "West Side Health Centre",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.5912601,
    lng: -62.6495036,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-003",
    name: "Scotia Square Medical Clinic",
    city: "Halifax",
    address: "5201 Duke Street",
    phone: "Not listed",
    lat: 44.6494113,
    lng: -63.576233,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-004",
    name: "Clayton Park Walk-In Medical Clinic",
    city: "Halifax",
    address: "278 Lacewood Drive",
    phone: "Not listed",
    lat: 44.6616984,
    lng: -63.6548228,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-006",
    name: "Shubenacadie Health Centre",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.0888514,
    lng: -63.4038179,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-007",
    name: "SpryField Family Medicine Clinic",
    city: "Halifax",
    address: "315 Herring Cove Road",
    phone: "Not listed",
    lat: 44.6152315,
    lng: -63.6158116,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-008",
    name: "Montebello Medical",
    city: "Dartmouth",
    address: "249 Waverley Road",
    phone: "(902) 406-4444",
    lat: 44.698035,
    lng: -63.5480865,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-009",
    name: "Passport Health Halifax Travel Clinic",
    city: "Halifax",
    address: "5991 Spring Garden Road",
    phone: "Not listed",
    lat: 44.6410016,
    lng: -63.5867241,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-010",
    name: "Lacewood Medical Centre",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.6580954,
    lng: -63.6715015,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-011",
    name: "Woodlawn Medical Clinic",
    city: "Dartmouth",
    address: "92 Main Street",
    phone: "(902) 434-1500",
    lat: 44.6806929,
    lng: -63.5424016,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-012",
    name: "International Travel Clinic",
    city: "Dartmouth",
    address: "7 Mellor Avenue",
    phone: "(902) 481-5900",
    lat: 44.7083141,
    lng: -63.5778937,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-013",
    name: "Lawrencetown Community Health Centre",
    city: "Lawrencetown",
    address: "491 Main Street",
    phone: "Not listed",
    lat: 44.8825319,
    lng: -65.1584992,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-014",
    name: "Hydrostone Medical Centre",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.6675472,
    lng: -63.6068534,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-015",
    name: "Living Well Integrated Health Clinic",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.6497543,
    lng: -63.5949872,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-016",
    name: "Clydes Medical Practice & Walk-in Clinic",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.657745,
    lng: -63.6040034,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-017",
    name: "Dermatology & Medical Associates",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.6396843,
    lng: -63.5880449,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-019",
    name: "Community Health Centre",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.9722025,
    lng: -64.92628,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-020",
    name: "Membertou Clinic",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.1174462,
    lng: -60.1884523,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-021",
    name: "Middleton & Area Family Health Center",
    city: "",
    address: "462 Main Street",
    phone: "(902) 825-4202",
    lat: 44.9473573,
    lng: -65.0597289,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-022",
    name: "Family Practice Clinic",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.08648,
    lng: -63.4080061,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-023",
    name: "Health Clinic",
    city: "Dartmouth",
    address: "72 Finnian Row",
    phone: "Not listed",
    lat: 44.6967566,
    lng: -63.5635443,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-024",
    name: "Dr Maria Angwin Memorial – Wyse Road Health Clinic",
    city: "Dartmouth",
    address: "230 Wyse Road",
    phone: "(902) 433-2693",
    lat: 44.6749771,
    lng: -63.5843603,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-025",
    name: "Eskasoni Health Center",
    city: "",
    address: "44 Spencers Lane",
    phone: "(902) 379-3200",
    lat: 45.940302,
    lng: -60.6259156,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-026",
    name: "Forever Healthy Allergy Clinic",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 43.8335777,
    lng: -66.1204473,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-027",
    name: "Bayers Lake QEII Community Outpatient Centre",
    city: "Beechville",
    address: "420 Susie Lake Crescent",
    phone: "Not listed",
    lat: 44.6475838,
    lng: -63.6849101,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "wk-028",
    name: "Atlantic Medical Clinc",
    city: "Halifax",
    address: "7001 Mumford Road",
    phone: "Not listed",
    lat: 44.64852,
    lng: -63.6185927,
    type: 'walkin' as const,
    waitMinutes: 30,
    volume: 'moderate' as const,
  },
  {
    id: "ph-001",
    name: "Rockingham Pharmacy",
    city: "Halifax",
    address: "30 Farnham Gate Road",
    phone: "(902) 457-1515",
    lat: 44.6723157,
    lng: -63.6646056,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-002",
    name: "Shoppers Drug Mart",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.7158231,
    lng: -63.6786384,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-003",
    name: "Lawtons",
    city: "",
    address: "810 East River Road",
    phone: "(902) 752-1860",
    lat: 45.5735327,
    lng: -62.6418145,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-004",
    name: "Shoppers Drug Mart",
    city: "",
    address: "Address not listed",
    phone: "(902) 752-0280",
    lat: 45.5707703,
    lng: -62.6416721,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-005",
    name: "Hubbards Pharmasave",
    city: "Hubbards",
    address: "11 Highway 329",
    phone: "(902) 857-1743",
    lat: 44.6360635,
    lng: -64.0706753,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-006",
    name: "Shoppers Drug Mart",
    city: "Dartmouth",
    address: "118 Wyse Road",
    phone: "(902) 464-9644",
    lat: 44.6712286,
    lng: -63.5767497,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-007",
    name: "Lawtons Lord Nelson #114",
    city: "Halifax",
    address: "5665 Spring Garden Road",
    phone: "Not listed",
    lat: 44.6426458,
    lng: -63.5789373,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-008",
    name: "Lawton's",
    city: "Halifax",
    address: "6155 North Street",
    phone: "(902) 453-4774",
    lat: 44.65307,
    lng: -63.5979948,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-009",
    name: "Lawton's",
    city: "Lower Sackville",
    address: "157 Cobequid Road",
    phone: "Not listed",
    lat: 44.7572291,
    lng: -63.6604745,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-010",
    name: "Lawtons",
    city: "Halifax",
    address: "287 Lacewood Drive",
    phone: "Not listed",
    lat: 44.6636806,
    lng: -63.6585231,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-011",
    name: "Guardian",
    city: "Halifax",
    address: "535 Larry Uteck Boulevard",
    phone: "(902) 407-4373",
    lat: 44.7012997,
    lng: -63.6790245,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-012",
    name: "Shoppers Drug Mart",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.0911181,
    lng: -64.3619729,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-013",
    name: "Shoppers Drug Mart",
    city: "Cole Harbour",
    address: "4 Forest Hills Parkway",
    phone: "(902) 434-9800",
    lat: 44.6727829,
    lng: -63.492478,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-014",
    name: "Pharmasave",
    city: "Kingston",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.9879158,
    lng: -64.9487048,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-015",
    name: "Shoppers Drug Mart",
    city: "Bedford",
    address: "1595 Bedford Highway",
    phone: "(902) 835-3354",
    lat: 44.7342901,
    lng: -63.6542401,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-016",
    name: "Shoppers Drug Mart",
    city: "",
    address: "6960 Mumford Road",
    phone: "(902) 453-7750",
    lat: 44.645137,
    lng: -63.6190662,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-017",
    name: "MacQuarries Pharmasave - West End in Truro",
    city: "",
    address: "510 Prince Street",
    phone: "Not listed",
    lat: 45.3651106,
    lng: -63.2865983,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-018",
    name: "MacKinnons Pharmasave",
    city: "Antigonish",
    address: "243 Main Street",
    phone: "Not listed",
    lat: 45.6223463,
    lng: -61.9902724,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-019",
    name: "Pharmasave",
    city: "",
    address: "213 Commercial Street",
    phone: "(902) 538-3185",
    lat: 45.0441346,
    lng: -64.736545,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-020",
    name: "MacQuarries Pharmasave - The Esplanade in Truro",
    city: "",
    address: "179 Esplanade Street",
    phone: "(902) 895-1681",
    lat: 45.3636732,
    lng: -63.273915,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-021",
    name: "Pharmasave",
    city: "",
    address: "648 Highway 2",
    phone: "Not listed",
    lat: 45.2534956,
    lng: -63.27901,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-022",
    name: "MacQuarries Pharmasave – Bible Hill Centre",
    city: "",
    address: "241 Pictou Road",
    phone: "Not listed",
    lat: 45.3807674,
    lng: -63.2443575,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-023",
    name: "Pharmasave",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.94305,
    lng: -65.0684928,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-024",
    name: "Lawtons",
    city: "Porters Lake",
    address: "5228 Highway 7",
    phone: "Not listed",
    lat: 44.744143,
    lng: -63.2843473,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-025",
    name: "Superstore Pharmacy",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.6090851,
    lng: -62.0153738,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-026",
    name: "Walmart Pharmacy",
    city: "Antigonish",
    address: "50 Market Street",
    phone: "(902) 867-1279",
    lat: 45.608416,
    lng: -62.0144868,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-027",
    name: "Haliburtons Pharmacare",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.6227376,
    lng: -61.9897211,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-028",
    name: "Scotia Pharmacy",
    city: "Halifax",
    address: "2131 Gottingen Street",
    phone: "(902) 429-5777",
    lat: 44.6522223,
    lng: -63.5833984,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-029",
    name: "Lawtons Drugs",
    city: "Halifax",
    address: "5201 Duke Street",
    phone: "Not listed",
    lat: 44.6495173,
    lng: -63.5754819,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-030",
    name: "Shoppers Drug Mart",
    city: "Halifax",
    address: "3430 Joseph Howe Drive",
    phone: "Not listed",
    lat: 44.6543273,
    lng: -63.6307287,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-031",
    name: "Shoppers Drug Mart",
    city: "Halifax",
    address: "6139 Quinpool Road",
    phone: "Not listed",
    lat: 44.6468566,
    lng: -63.5946588,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-032",
    name: "The Medicine Shoppe Pharmacy",
    city: "Halifax",
    address: "70 Lacewood Drive",
    phone: "(902) 406-4110",
    lat: 44.6605544,
    lng: -63.6381351,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-033",
    name: "Shoppers Drug Mart",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.6427472,
    lng: -63.5776768,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-034",
    name: "The Medicine Shoppe Pharmacy",
    city: "Lower Sackville",
    address: "601 Sackville Drive",
    phone: "(902) 252-7700",
    lat: 44.7688287,
    lng: -63.6859172,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-035",
    name: "Shoppers Drug Mart",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.194819,
    lng: -59.9553002,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-036",
    name: "Lawton's Pharmacy",
    city: "Lower Sackville",
    address: "665 Sackville Drive",
    phone: "Not listed",
    lat: 44.7703209,
    lng: -63.6884419,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-037",
    name: "Shoppers Drug Mart",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.6222059,
    lng: -61.9929179,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-038",
    name: "Lawtons Pharmacy",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.6169123,
    lng: -61.9823305,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-039",
    name: "Lawtons",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.135741,
    lng: -60.192515,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-040",
    name: "Pharmasave",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.1375067,
    lng: -60.1942424,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-041",
    name: "Pollett Drug Store",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.1403531,
    lng: -60.1951971,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-042",
    name: "Shoppers Drug Mart",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.1099765,
    lng: -60.2225316,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-043",
    name: "Shoppers Drug Mart",
    city: "Sydney",
    address: "254 Prince Street",
    phone: "(902) 562-1144",
    lat: 46.1378943,
    lng: -60.1868166,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-044",
    name: "Lawton's Drug Store",
    city: "Dartmouth",
    address: "46 Portland Street",
    phone: "Not listed",
    lat: 44.6650687,
    lng: -63.5670059,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-045",
    name: "Lawtons",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.3856626,
    lng: -64.5151711,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-046",
    name: "Pharmasave",
    city: "Bridgewater",
    address: "215 Dominion Street",
    phone: "(902) 543-3418",
    lat: 44.3705489,
    lng: -64.5257476,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-047",
    name: "Guardian",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.3837083,
    lng: -64.5140914,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-048",
    name: "Crowell’s Pharmacy",
    city: "Halifax",
    address: "205 Herring Cove Road",
    phone: "(902) 477-4650",
    lat: 44.6235005,
    lng: -63.6179805,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-049",
    name: "Shoppers Drug Mart",
    city: "Fall River",
    address: "3260 Highway 2",
    phone: "Not listed",
    lat: 44.8167984,
    lng: -63.6104728,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-050",
    name: "Elmsdale Pharmacy",
    city: "Elmsdale",
    address: "269 Highway 214",
    phone: "(902) 883-2227",
    lat: 44.9770612,
    lng: -63.5052084,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-051",
    name: "Shoppers Drug Mart",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.7011058,
    lng: -63.6872286,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-052",
    name: "Guardian",
    city: "Hammonds Plains",
    address: "3 Kingswood Drive",
    phone: "(902) 835-5100",
    lat: 44.7234515,
    lng: -63.7375541,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-053",
    name: "Pharmasave",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.2113313,
    lng: -60.02186,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-054",
    name: "Shoppers Drug Mart",
    city: "",
    address: "131 King Street",
    phone: "Not listed",
    lat: 46.2156546,
    lng: -60.263394,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-055",
    name: "PharmaChoice",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.6347785,
    lng: -61.0084939,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-056",
    name: "Lawtons Drugs",
    city: "Halifax",
    address: "16 Dentith Road",
    phone: "(902) 479-1631",
    lat: 44.6129519,
    lng: -63.6198206,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-057",
    name: "Lawton drugs",
    city: "Upper Tantallon",
    address: "5110 St Margarets Bay Road",
    phone: "Not listed",
    lat: 44.6854455,
    lng: -63.8760513,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-058",
    name: "Shoppers Drug Mart",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.6161774,
    lng: -61.3513831,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-059",
    name: "The Medicine Shoppe",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.6150404,
    lng: -61.3503344,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-060",
    name: "Lawtons Drugs",
    city: "Sheet Harbour",
    address: "22624 Highway 7",
    phone: "(902) 885-2463",
    lat: 44.920487,
    lng: -62.5343065,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-061",
    name: "Pharmasave",
    city: "Sydney Forks",
    address: "2372 Kings Road",
    phone: "Not listed",
    lat: 46.0691955,
    lng: -60.2849544,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-062",
    name: "Shoppers Drug Mart",
    city: "Sherbrooke",
    address: "14 Main Street",
    phone: "Not listed",
    lat: 45.1420245,
    lng: -61.9834111,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-063",
    name: "Pharmasave",
    city: "",
    address: "1624 Sackville Drive",
    phone: "(902) 252-7772",
    lat: 44.7944765,
    lng: -63.7242409,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-064",
    name: "Lawtons",
    city: "Halifax",
    address: "2615 Northwood Terrace",
    phone: "(902) 454-8323",
    lat: 44.6572587,
    lng: -63.5921625,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-065",
    name: "Pharmasave",
    city: "Glace Bay",
    address: "605 Main Street",
    phone: "Not listed",
    lat: 46.1969892,
    lng: -59.9557044,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-066",
    name: "Shoppers Drug Mart",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.5424038,
    lng: -64.7170572,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-067",
    name: "PharmaChoice",
    city: "Coldbrook",
    address: "6637 Highway 1",
    phone: "Not listed",
    lat: 45.0618592,
    lng: -64.5994458,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-068",
    name: "Lawtons Drugs #112",
    city: "Halifax",
    address: "7071 Bayers Road",
    phone: "Not listed",
    lat: 44.6541222,
    lng: -63.6273462,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-069",
    name: "Bayside Pharmacy",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.4097736,
    lng: -63.7566474,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-070",
    name: "Shoppers Drug Mart",
    city: "Dartmouth",
    address: "21 Micmac Boulevard",
    phone: "Not listed",
    lat: 44.6862417,
    lng: -63.5597494,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-071",
    name: "Guardian",
    city: "",
    address: "375 Pleasant Street",
    phone: "(902) 469-2009",
    lat: 44.649548,
    lng: -63.5447372,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-072",
    name: "Lawtons Drugs #2562",
    city: "Amherst",
    address: "2 Lawrence Street",
    phone: "Not listed",
    lat: 45.8324025,
    lng: -64.2139882,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-073",
    name: "PharmaChoice",
    city: "Cole Harbour",
    address: "920 Cole Harbour Road",
    phone: "(902) 462-4187",
    lat: 44.6705853,
    lng: -63.4979675,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-074",
    name: "Stewiacke Pharmacy",
    city: "Stewiacke",
    address: "49 Riverside Avenue",
    phone: "(902) 639-2987",
    lat: 45.138208,
    lng: -63.3520476,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-075",
    name: "Shoppers Drug Mart",
    city: "Halifax",
    address: "5595 Fenwick Street",
    phone: "Not listed",
    lat: 44.6381909,
    lng: -63.5746247,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-076",
    name: "Guardian",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.1764893,
    lng: -63.7215723,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-077",
    name: "Stone's Pharmasave",
    city: "Baddeck",
    address: "491 Chebucto Street",
    phone: "(902) 295-2404",
    lat: 46.1002772,
    lng: -60.751476,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-078",
    name: "Teasdale Pharmacy",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.614039,
    lng: -61.9702477,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-079",
    name: "Forest Hill Guardian",
    city: "",
    address: "7907 Highway 7",
    phone: "(902) 889-2733",
    lat: 44.787272,
    lng: -63.1490052,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-080",
    name: "Hatchet Lake Guardian",
    city: "",
    address: "2273 Prospect Road",
    phone: "(902) 852-3343",
    lat: 44.5609527,
    lng: -63.7316806,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-081",
    name: "Timberlea Pharmacy",
    city: "Timberlea",
    address: "1800 St Margarets Bay Road",
    phone: "(902) 876-2833",
    lat: 44.6447397,
    lng: -63.7117326,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-082",
    name: "Pharmasave Brookline Pharmacy",
    city: "",
    address: "6 Bloom Lane",
    phone: "(902) 835-9111",
    lat: 44.7075476,
    lng: -63.7091053,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-083",
    name: "Loblaw Pharmacy",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.6585532,
    lng: -63.6054966,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-084",
    name: "Medicine Shoppe Pharmacy",
    city: "",
    address: "288 Welton Street",
    phone: "(902) 567-1141",
    lat: 46.1435749,
    lng: -60.164051,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-085",
    name: "Medicine Shoppe Pharmacy",
    city: "",
    address: "336 Kings Road",
    phone: "(902) 539-6640",
    lat: 46.1254848,
    lng: -60.1997968,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-086",
    name: "The Medicine Shoppe Pharmacy",
    city: "Halifax",
    address: "2958 Oxford Street",
    phone: "(902) 405-3784",
    lat: 44.653323,
    lng: -63.6085381,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-087",
    name: "Pharmasave",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.6547119,
    lng: -63.5921776,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-088",
    name: "PharmaChoice",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.2141928,
    lng: -60.2618713,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-089",
    name: "The Medicine Shoppe Pharmacy",
    city: "Dartmouth",
    address: "133 Baker Drive",
    phone: "(902) 461-2244",
    lat: 44.6621263,
    lng: -63.5293515,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-090",
    name: "The Medicine Shoppe Pharmacy",
    city: "Upper Tantallon",
    address: "3622 Hammonds Plains Road",
    phone: "(902) 820-0392",
    lat: 44.7040822,
    lng: -63.8569053,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-091",
    name: "Walmart Pharmacy",
    city: "Sydney",
    address: "65 Keltic Drive",
    phone: "(902) 562-3353",
    lat: 46.1092789,
    lng: -60.2261564,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-092",
    name: "Walmart Pharmacy",
    city: "North Sydney",
    address: "116 King Street",
    phone: "(902) 794-6021",
    lat: 46.2132864,
    lng: -60.2644354,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-093",
    name: "Walmart Pharmacy",
    city: "Sydney",
    address: "80 Sydney Port Access Road",
    phone: "(902) 562-1110",
    lat: 46.1516238,
    lng: -60.147736,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-094",
    name: "Walmart Pharmacy",
    city: "Conway",
    address: "492 Highway 303",
    phone: "(902) 245-6020",
    lat: 44.5998829,
    lng: -65.7734248,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-095",
    name: "The Medicine Shoppe",
    city: "Truro",
    address: "245 Robie Street",
    phone: "Not listed",
    lat: 45.371026,
    lng: -63.3042897,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-096",
    name: "Costco Pharmacy",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.6565335,
    lng: -63.6758985,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-097",
    name: "Costco Pharmacy",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.70483,
    lng: -63.5667781,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-098",
    name: "Pharmasave",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 43.6628804,
    lng: -65.8001946,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-099",
    name: "Pharmasave Middle Sackville",
    city: "Middle Sackville",
    address: "1727 Sackville Drive",
    phone: "(902) 252-7772",
    lat: 44.7963565,
    lng: -63.7299078,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-100",
    name: "I.D.A.",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.6463189,
    lng: -63.5934393,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-101",
    name: "Pharmasave",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.1186848,
    lng: -60.1916181,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-102",
    name: "Pharmaprix",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.2423643,
    lng: -60.2293187,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-103",
    name: "Guardian",
    city: "Kentville",
    address: "81 Exhibition Street",
    phone: "(902) 678-2799",
    lat: 45.0842619,
    lng: -64.4973516,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-104",
    name: "Atlantic Superstore",
    city: "Halifax",
    address: "1075 Barrington Street",
    phone: "Not listed",
    lat: 44.6380291,
    lng: -63.5689516,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-105",
    name: "Shoppers Drug Mart",
    city: "Lower Sackville",
    address: "776 Sackville Drive",
    phone: "Not listed",
    lat: 44.7728413,
    lng: -63.6933427,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-106",
    name: "Sobeys",
    city: "Halifax",
    address: "1120 Queen Street",
    phone: "Not listed",
    lat: 44.6373325,
    lng: -63.5745058,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-107",
    name: "Shoppers Drug Mart",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 43.8454552,
    lng: -66.1090722,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-108",
    name: "Shoppers Drug Mart",
    city: "Halifax",
    address: "6025 Almon Street",
    phone: "Not listed",
    lat: 44.657432,
    lng: -63.5998361,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-109",
    name: "Lawton's",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.3544302,
    lng: -63.2949658,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-110",
    name: "Lawtons Drugs",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.0697296,
    lng: -64.4401223,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-111",
    name: "Pharmasave",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 45.8229915,
    lng: -64.1907877,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-112",
    name: "Pharmasave",
    city: "Wolfville",
    address: "442 Main Street",
    phone: "Not listed",
    lat: 45.0917055,
    lng: -64.362504,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-113",
    name: "Cochrane's Pharmasave",
    city: "Hantsport",
    address: "24 Main Street",
    phone: "Not listed",
    lat: 45.0665937,
    lng: -64.1798066,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-114",
    name: "Shoppers Drug Mart",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.6795788,
    lng: -63.5363098,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-115",
    name: "Enfield PharmaChoice",
    city: "Enfield",
    address: "284 Highway 2",
    phone: "(902) 883-9432",
    lat: 44.9445886,
    lng: -63.5354916,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-116",
    name: "Lawtons",
    city: "Dartmouth",
    address: "Address not listed",
    phone: "(902) 462-7400",
    lat: 44.6808023,
    lng: -63.542609,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-117",
    name: "Lawtons Drugs",
    city: "Musquodoboit Harbour",
    address: "8003 Highway 7",
    phone: "Not listed",
    lat: 44.7897126,
    lng: -63.1440291,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-118",
    name: "Lawtons",
    city: "Halifax",
    address: "27 Peakview Way",
    phone: "Not listed",
    lat: 44.6988218,
    lng: -63.6887988,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-119",
    name: "Lawton's Drugs",
    city: "Bedford",
    address: "965 Bedford Highway",
    phone: "Not listed",
    lat: 44.715981,
    lng: -63.6775864,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-120",
    name: "Poulain's Pharmacy, Foord Street Clinic",
    city: "Stellarton",
    address: "277 Foord Street",
    phone: "Not listed",
    lat: 45.557848,
    lng: -62.6598436,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-121",
    name: "Pharmasave",
    city: "Stellarton",
    address: "233 Foord Street",
    phone: "Not listed",
    lat: 45.5599346,
    lng: -62.6595691,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-122",
    name: "Shoppers Drug Mart",
    city: "Greenwood",
    address: "1124 Bridge Street",
    phone: "(403) 257-1109",
    lat: 44.9705147,
    lng: -64.9380046,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-123",
    name: "Pharmasave",
    city: "Upper Tantallon",
    address: "5216 St Margarets Bay Road",
    phone: "Not listed",
    lat: 44.6880666,
    lng: -63.8807084,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-124",
    name: "Shoppers Drug Mart",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.6713955,
    lng: -63.5244127,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-125",
    name: "Pharmasave",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.8415241,
    lng: -65.2918163,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-126",
    name: "Lawtons Drugs",
    city: "Windsor",
    address: "25 Wentworth Road",
    phone: "Not listed",
    lat: 44.9914466,
    lng: -64.1292021,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-127",
    name: "Pharmasave",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.1567616,
    lng: -60.1837212,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-128",
    name: "Pharmasave",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.2029424,
    lng: -66.1422186,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-129",
    name: "Pharmasave",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.2498453,
    lng: -60.087879,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-130",
    name: "Lawton's",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 46.2493988,
    lng: -60.087203,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-131",
    name: "Guardian",
    city: "",
    address: "2374 Highway 206",
    phone: "(902) 226-3133",
    lat: 45.5108206,
    lng: -61.025346,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-132",
    name: "Pharmasave",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 43.8359152,
    lng: -66.1196419,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-133",
    name: "PharmaChoice",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 43.8367952,
    lng: -66.1195903,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-134",
    name: "PharmaChoice",
    city: "",
    address: "5208 Main Street",
    phone: "Not listed",
    lat: 45.7357538,
    lng: -63.8676143,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-135",
    name: "Pharmasave",
    city: "",
    address: "Address not listed",
    phone: "Not listed",
    lat: 44.4487495,
    lng: -64.3818997,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-136",
    name: "Chisholm's Pharmacy",
    city: "Aylesford",
    address: "2710 Highway 1",
    phone: "Not listed",
    lat: 45.0279425,
    lng: -64.8357003,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-137",
    name: "Shoppers Drug Mart",
    city: "Truro",
    address: "68 Robie Street",
    phone: "Not listed",
    lat: 45.367956,
    lng: -63.3094381,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
  {
    id: "ph-138",
    name: "Shoppers Drug Mart",
    city: "Elmsdale",
    address: "295 Highway 214",
    phone: "(902) 883-3630",
    lat: 44.9805066,
    lng: -63.5069481,
    type: 'pharmacy' as const,
    volume: 'moderate' as const,
    status: 'open' as const,
  },
];
